<script>
  import { fade, fly } from "svelte/transition";
  import { isCartDrawerOpen, isSearchOpen } from "../store/store";
  import { clickOutside } from "../utils/click-outside";
  import HeaderSearch from "./HeaderSearch.svelte";

  let drawerEl;
  let searchPanel;

  function closeDrawer() {
    document.querySelector('body')?.classList.remove('overflow-hidden')
    isSearchOpen.set(false)
  }

    function openSearch() {
        document.querySelector('body')?.classList.add('overflow-hidden')
        isSearchOpen.set(true);
        
        setTimeout(() => {
            searchPanel?.focus();
        }, 300);
    }
    //open search from event
    document.addEventListener('toggle-search', () => {
        openSearch()
    })
</script>

{#if $isSearchOpen}
  <div class="relative z-50" aria-labelledby="slide-over-title" role="dialog" aria-modal="true">
    <div
      in:fade={{ duration: 500 }}
      out:fade={{ duration: 500 }}
      class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
    />
    <div class="fixed inset-0 overflow-hidden">
      <div class="absolute inset-0 overflow-hidden">
        <div
          class="pointer-events-none fixed inset-y-0 right-0 flex max-w-full pl-10 focus:outline-none"
          tabindex="-1"
          use:clickOutside={() => closeDrawer()}
          bind:this={drawerEl}
        >
          <div
            in:fly={{ duration: 500, x: 500, opacity: 100 }}
            out:fly={{ duration: 500, x: 500, opacity: 100 }}
            class="pointer-events-auto w-screen max-w-md"
          >
            <div
              class="flex h-full flex-col overflow-y-scroll dark:bg-neutral-900 bg-white shadow-xl"
            >
              <div class="flex-1 overflow-y-auto py-6 px-4 sm:px-6">
                <div class="flex items-start justify-between my-4">
                  <h2
                    class="text-2xl flex gap-4 items-center font-medium dark:text-gray-50 text-gray-900"
                    id="slide-over-title"
                  >
                    Search
                  </h2>
                  <button
                  on:click={() => closeDrawer()}
                  type="button"
                  class="-m-2 p-2 text-gray-400 dark:text-gray-200 hover:text-gray-500"
                >
                  <span class="sr-only">Close</span>
                  <!-- Heroicon name: outline/x-mark -->
                  <svg
                    class="h-6 w-6"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke-width="1.5"
                    stroke="currentColor"
                    aria-hidden="true"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="M6 18L18 6M6 6l12 12"
                    />
                  </svg>
                </button>
                  
                </div>
                
                <div class="mt-8">
                    <HeaderSearch bind:inputEl={searchPanel} search="" floating={false} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
{/if}
